import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from '@/app/App'
import { initSentry } from '@/core/telemetry/sentry.init'

// Inicializa Sentry ANTES do createRoot pra interceptar erros de boot.
// Sem VITE_SENTRY_DSN setado, vira no-op silencioso.
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
